/*
  This file contains the styles for the saved sections dialog.
*/

import { styled } from '@mui/material/styles';
import { Box, Stack } from '@mui/material';
import CustomModal from 'components/CustomModal';

export const CustomModalWrapper = styled(CustomModal, {
  shouldForwardProp: (prop) => prop !== 'smallScreen',
})(({ smallScreen }) => ({
  '& .MuiPaper-root': {
    borderRadius: smallScreen ? 'unset' : '24px',
    width: 550,
    maxWidth: 'unset',
    margin: 0,
    maxHeight: 'unset',
  },
}));

export const HeaderWrapper = styled(Stack)({
  borderBottom: '1px solid #d3d3d35c',
  padding: '15px 20px 10px 20px',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',

  '& .title': {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: '32px',
    letterSpacing: '0.15px',
    color: '#000000',
  },

  '& .closeIcon': {
    '& svg': {
      fontSize: 20,
      '& path': {
        fill: '#616161',
      },
    },
  },
});

export const FooterWrapper = styled(Stack)({
  padding: '15px 20px',
  gap: '10px',
  borderTop: '1px solid #d3d3d35c',

  '& .saveBtn': {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '24px',
    color: '#FFFFFF',
    borderRadius: 6,
    height: 40,
  },
  '& .cancelBtn': {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '24px',
    color: '#6868FE',
  },
});

export const ContentWrapper = styled(Stack)({
  padding: '15px 20px',
  maxHeight: 400,
  overflowY: 'auto',

  '& .sectionTitle': {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '19.12px',
    color: 'rgba(0, 0, 0, 1)',
  },

  '& .item': {
    padding: '6px',
    cursor: 'pointer',
    borderRadius: 8,
    margin: '5px 0px',
  },

  '& .iconCnt': {
    height: 36,
    width: 36,
    borderRadius: 100,
    backgroundColor: 'rgba(239, 242, 243, 1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& svg': {
      height: 14,
      width: 14,
      '& path': {
        stroke: 'rgba(97, 97, 97, 1)',
      },
    },
  },

  '& .doneIcon': {
    height: 22,
    width: 22,
    color: 'rgba(104, 104, 254, 1)',
    '& path': {
      stroke: 'rgba(104, 104, 254, 1)',
    },
  },
});

export const SearchCnt = styled(Box)({
  padding: '15px 20px 0px 20px',
});
